import { Breadcrumb, Upload, Switch, Modal, Row, Col, Button, DatePicker, Radio, Card, Input, Popconfirm, Checkbox, Empty } from 'antd';
import React, { useEffect, useState, useRef } from 'react';
import { DownloadOutlined, PrinterOutlined } from '@ant-design/icons';
import axios from 'axios';
import JoditEditor from "jodit-react";
const PreviewWordModal = (props) => {
    const [switchMode, setSwitchMode] = useState(false);
    const editor = useRef(null);
    const config = {
        readonly: false, // all options from https://xdsoft.net/jodit/doc/
        uploader: {
            insertImageAsBase64URI: true,
            // url: `${axios.defaults.baseURL}/api/literacy/admin/editor/file`
        },
        language: 'zh_tw'
    };
    const handleDownload = () => {
        // console.log(props.file);
        // console.log(props.file.file_id);
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.setAttribute('download', `${props.file.file_client_name}`);
                document.body.appendChild(link);
                link.click();
                link.remove();
            })
    }
    const handlePrint = () => {
        axios
            .get('/cramSchool/api/media/classify_structure_type_file_download', {
                responseType: 'blob',
                params: {
                    file_id: props.file.file_id
                }
            })
            .then((response) => {
                // var blob = new Blob([response.data], { type: 'application/pdf' }); //this make the magic
                // var blobURL = URL.createObjectURL(response.data);

                let iframe = document.createElement('iframe'); //load content in an iframe to print later
                document.body.appendChild(iframe);

                iframe.style.display = 'none';
                // iframe.src = blobURL;
                iframe.onload = function () {
                    setTimeout(function () {
                        iframe.focus();
                        iframe.contentWindow.print();
                    }, 1);
                };
            })
    }
    const handleOnChange = (checked) => {
        // console.log(checked);
        setSwitchMode(checked)
    }
    useEffect(() => {
        setSwitchMode(false);
    }, [props.file])
    return (
        <Modal
            open={props.open}
            // onOk={hideModal}
            onCancel={e => props.setOpen(false)}
            footer={false}
            width={800}
            style={{ padding: '20px' }}
        >
            <Row justify={'space-between'} style={{ paddingRight: '20px' }} gutter={[8, 16]} align={'middle'}>
                <Col>
                    <Switch checkedChildren="編輯" unCheckedChildren="預覽" defaultChecked={false} onChange={handleOnChange} />
                </Col>
                <Col style={{ paddingTop: '10px' }}>
                    <Row gutter={8}>
                        <Col>
                            <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<PrinterOutlined />}
                                // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                                // onClick={handleDownload}
                                onClick={handlePrint}
                            >列印</Button>
                        </Col>
                        <Col>
                            <Button type='primary' style={{ display: "inline-flex", alignItems: "center" }} icon={<DownloadOutlined />}
                                // onClick={e => window.open(`${axios.defaults.baseURL}/cramSchool/api/media/classify_structure_type_file_download?file_id=${props.file_id}`)}
                                onClick={handleDownload}
                            >檔案下載</Button>
                        </Col>
                    </Row>
                </Col>
                {switchMode ? <>
                    <Col span={24}>
                        <JoditEditor
                            ref={editor}
                            value={props.content}
                            config={config}
                            tabIndex={1} // tabIndex of textarea
                            onBlur={content => props.setContent(content)} // preferred to use only this option to update the content for performance reasons
                            height={500}
                            allowResizeX={true}
                            allowResizeY={true}
                        />
                    </Col>
                    <Col span={24}>
                        <Row gutter={[10, 10]} justify={"center"}>
                            <Col>
                                <Button size='large' style={{ background: '#4a4a4a', color: '#ffffff' }} onClick={(e) => props.setOpen(false)} block>取消</Button>
                            </Col>
                            <Col >
                                <Button
                                    onClick={e => props.handleEdit(props.file.file_id)}
                                    size='large' style={{ background: '#f09a45', color: '#ffffff' }} block
                                >修改</Button>
                            </Col>
                        </Row>
                    </Col>
                </> : <>
                    <Col span={24} style={{ overflowX: 'scroll' }}>
                        {/* <div ref={el => {
                            if (el) {
                                el.style.setProperty('width', '100%', 'important');
                            }
                        }}> */}
                        <span
                            dangerouslySetInnerHTML={{ __html: props.content }}></span>
                        {/* </div> */}
                    </Col>
                </>}
            </Row>

        </Modal>
    )
}
export default PreviewWordModal;